import React, { useEffect, useState } from 'react';
import { previewPeriodTape, type TapeEvidenceScope } from './periodApi';
import { apiErrorMessage } from '../api/abfApi';
import { Button } from '../onboarding/review/reviewStyles';
import { Note } from '../onboarding/review/contractReviewStyles';

export default function TapeFileReview({ facilityId, periodId, periodLabel, asOf, file, busy, onConfirm, onCancel }: {
  facilityId: number; periodId: number; periodLabel: string; asOf: string; file: File; busy: boolean;
  onConfirm: () => void; onCancel: () => void;
}) {
  const [scope, setScope] = useState<TapeEvidenceScope | null>(null);
  const [error, setError] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  useEffect(() => {
    let active = true;
    setScope(null); setError(''); setConfirmed(false);
    void previewPeriodTape(facilityId, periodId, file, asOf).then(result => {
      if (active) setScope(result);
    }).catch(failure => { if (active) setError(apiErrorMessage(failure, 'The source could not be checked. Nothing was imported.')); });
    return () => { active = false; };
  }, [facilityId, periodId, file, asOf]);
  return <Note style={{ marginTop: 12 }}>
    <h3>Review before importing</h3>
    <p><strong>{file.name}</strong> · {(file.size / 1024).toFixed(1)} KB</p>
    <p>Destination: <strong>{scope?.facilityCode || `Facility #${facilityId}`} · {periodLabel}</strong> · Tape as of <strong>{asOf}</strong></p>
    {error ? <p role="alert">{error}</p> : !scope ? <p role="status">Checking source declarations…</p> : <>
      <p>{scope.message}</p>
      {Object.entries(scope.sourceDeclarations).map(([key, values]) => <p key={key}>{key.replace(/_/g, ' ')}: <strong>{values.join(', ')}</strong></p>)}
      <label style={{ display: 'flex', gap: 8, margin: '12px 0' }}>
        <input type="checkbox" checked={confirmed} disabled={busy} onChange={e => setConfirmed(e.target.checked)} />
        I checked the original source: this is the tape for {periodLabel}, as of {asOf}, for this facility.
      </label>
    </>}
    <div style={{ display: 'flex', gap: 8 }}>
      <Button type="button" $variant="primary" disabled={busy || !scope || !confirmed || !!error} onClick={onConfirm}>Import into {periodLabel}</Button>
      <Button type="button" disabled={busy} onClick={onCancel}>Cancel file</Button>
    </div>
    <p>Changing the review period clears this selection. Importing records a candidate; release is a separate review.</p>
  </Note>;
}
